import { render, staticRenderFns } from "./PaymentConfirmModal.vue?vue&type=template&id=2c01fc19&"
import script from "./PaymentConfirmModal.vue?vue&type=script&lang=js&"
export * from "./PaymentConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports